import { Typography } from "@circle-react-uikit/Typography";
import type { TypographyProps } from "@circleco/compass/components/Typography";
import { Typography as TypographyCompass } from "@circleco/compass/components/Typography";
import { omit } from "lodash";
import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

export interface FormHeadingBlockProps extends ComponentPropsWithRef<"div"> {
  textType?: "title" | "subtitle";
  value?: string;
}

export const FormHeadingBlock = forwardRef<
  HTMLDivElement,
  FormHeadingBlockProps
>(({ value, textType = "title", className, ...rest }, ref) => {
  const { isCircleV4 } = useCircleV4();
  const isTitleType = textType === "title";

  const TypographyUIKit = isTitleType ? Typography.TitleMd : Typography.TitleSm;
  const TypographyComponent = isCircleV4 ? TypographyCompass : TypographyUIKit;

  const elementProps = omit(rest, ["blockPath"]);
  const typographyProps: TypographyProps = {};

  if (isCircleV4) {
    typographyProps.variant = isTitleType ? "heading-xl" : "body-md";
  }

  return (
    <div ref={ref} className={classNames("mb-2", className)} {...elementProps}>
      <TypographyComponent {...typographyProps}>
        {value || t("builder_ui.prop_type.text_content_empty")}
      </TypographyComponent>
    </div>
  );
});

FormHeadingBlock.displayName = "FormHeadingBlock";
